import { render } from "./mainLayout.vue?vue&type=template&id=6f2e08d7"
import script from "./mainLayout.vue?vue&type=script&lang=js"
export * from "./mainLayout.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\TEHNOLAND\\megamarketAdmin\\adm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__